import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function SuccessModal(props) {

    // Fill template with form data
    const fillTemplate = (template, data) => {
        if(!template) return ''
        var out = template
        Object.keys(data).forEach(k => {
            out = out.replace(new RegExp(`\{{[ ]{0,1}${k}[ ]{0,1}\}}`, 'g'), data[k].value)
        })
        return out
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title
                    id="contained-modal-title-vcenter"
                    className='text-success w-100'
                    dangerouslySetInnerHTML={{ __html: fillTemplate(props.config.successMessage?.title, props.formdata) }}>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div dangerouslySetInnerHTML={{ __html: fillTemplate(props.config.successMessage?.content, props.formdata) }}></div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='outline-success' onClick={props.onHide}>Fermer</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default SuccessModal